/**
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 *
 * THIS FILE IS MANAGED CENTRALLY BY THE `common-code` REPO.
 * IT COULD BE AUTO-REPLACED AT ANY TIME.
 * DO NOT MAKE CUSTOM CHANGES TO THIS FILE.
 * @see https://gitlab.com/dea-aero/development/common-code
 *
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 */
import Stack from "@mui/material/Stack";
import InfoIcon from "@mui/icons-material/Info";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import CancelIcon from "@mui/icons-material/Cancel";


export const Info = ({children}) => (
    <Stack direction="row" spacing={2}><InfoIcon color="info"/><i>{children}</i></Stack>
)
export const Success = ({children}) => (
    <Stack direction="row" spacing={2}><CheckCircleIcon color="success"/><i>{children}</i></Stack>
)
export const Warning = ({children}) => (
    <Stack direction="row" spacing={2}><WarningIcon color="warning"/><i>{children}</i></Stack>
)
export const Error = ({children}) => (
    <Stack direction="row" spacing={2}><CancelIcon color="error"/><i>{children}</i></Stack>
)
